import http from 'common-module/src/util/http';

// 获取已用字段信息
export async function loadFieldListUsedDetail(data, config = {}) {
  return http.post('/profile/custom-field/used-detail', data, { ...config });
}

// 检测自定义字段是否能删除
export async function checkDeleteField(data) {
  return http.post('/profile/custom-field/get/field-issue-type', data);
}

export const deleteField = async id => {
  return http.post('/profile/custom-field/delete', { id });
};

/**
 * 自定义字段删除
 * @param {*} id
 * @returns
 */
export async function deleteProjectCustomField(id) {
  return http.post('/project/custom-field/delete', { id });
}

/**
 * 检测自定义字段能否删除
 * @param {*} id
 * @returns
 */
export async function checkProjectCustomFieldDelete(id) {
  return http.post('/project/custom-field/check/delete-field', { id });
}

export async function checkAddField(data) {
  return http.post('/project/custom-field/check/add-field', data, {
    assertResult: (res, data) => {
      if (data.code === '1606') {
        data.result = data.code;
        return true;
      }
      if (data.code === '200') {
        return true;
      }
    }
  });
}
